import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Footer.scss";

import logo1 from "../../assets/logo/logo_paypal_footer.svg";
import logo2 from "../../assets/logo/logo_visa_footer.svg";
import logo3 from "../../assets/logo/logo_maestro_footer.svg";
import logo4 from "../../assets/logo/logo_discover_footer.svg";
import logo5 from "../../assets/logo/logo_american-express_footer.svg";
import logoIUH from "../../image/Logo_IUH.png";

const Footer = () => {
  return (
    <footer className="modern-footer">
      <div className="container">
        {/* Top Banner: Newsletter Registration */}
        <div className="footer-newsletter-banner">
          <div className="row align-items-center g-3">
            <div className="col-lg-7">
              <h3>Đăng ký nhận thông tin & Khuyến mãi bãi xe</h3>
              <p>Nhận thông báo cập nhật tình trạng chỗ đỗ, bảng giá dịch vụ và các ưu đãi mới nhất.</p>
            </div>
            <div className="col-lg-5">
              <form className="newsletter-form" onSubmit={(e) => e.preventDefault()}>
                <input type="email" placeholder="Nhập địa chỉ email của bạn..." />
                <button type="submit">Đăng ký ngay</button>
              </form>
            </div>
          </div>
        </div>

        {/* Main Footer Links */}
        <div className="footer-body">
          <div className="row g-4">
            {/* Column 1: Brand & Contact */}
            <div className="col-lg-4 col-md-6 footer-brand">
              <div className="d-flex align-items-center gap-3 mb-3">
                <img src={logoIUH} alt="IUH Logo" className="logo-img" />
                <h5 className="mb-0">IUH Parking</h5>
              </div>
              <p className="pe-lg-3">
                Hệ thống quản lý bãi đỗ xe thông minh ứng dụng AI nhận diện biển số, công nghệ thẻ RFID và ví điện tử tự động dành cho sinh viên & cán bộ nhân viên.
              </p>
              <div className="contact-item">
                <i className="bi bi-geo-alt-fill"></i>
                <span>12 Nguyễn Văn Bảo, Phường Hạnh Thông, TP. Hồ Chí Minh</span>
              </div>
              <div className="contact-item">
                <i className="bi bi-telephone-fill"></i>
                <span>0283.8940 390 - ext 838</span>
              </div>
              <div className="contact-item">
                <i className="bi bi-envelope-fill"></i>
                <span>csm@iuh.edu.vn</span>
              </div>
            </div>

            {/* Column 2: Quick Links */}
            <div className="col-lg-2 col-md-6">
              <h6 className="footer-heading">Thông tin bãi xe</h6>
              <ul className="footer-links">
                <li><a href="#about">Giới thiệu hệ thống</a></li>
                <li><a href="#guide">Hướng dẫn gửi xe</a></li>
                <li><a href="#faq">Câu hỏi thường gặp</a></li>
                <li><a href="#privacy">Chính sách bảo mật</a></li>
                <li><a href="#terms">Điều khoản sử dụng</a></li>
              </ul>
            </div>

            {/* Column 3: Services & Pricing */}
            <div className="col-lg-3 col-md-6">
              <h6 className="footer-heading">Bảng giá & Dịch vụ</h6>
              <ul className="footer-links">
                <li><a href="#pricing-bike">Bảng giá xe máy / Xe điện</a></li>
                <li><a href="#pricing-car">Bảng giá ô tô</a></li>
                <li><a href="#monthly-pass">Vé tháng sinh viên & Giảng viên</a></li>
                <li><a href="#ewallet">Thanh toán ví điện tử VNPAY</a></li>
                <li><a href="#overnight">Dịch vụ gửi xe qua đêm</a></li>
              </ul>
            </div>

            {/* Column 4: Opening Hours & Tech */}
            <div className="col-lg-3 col-md-6">
              <h6 className="footer-heading">Thời gian hoạt động</h6>
              <div className="p-3 rounded-3" style={{ background: "rgba(255, 255, 255, 0.05)", border: "1px solid #334155" }}>
                <div className="d-flex justify-content-between mb-2 small text-light">
                  <span>Thứ 2 - Thứ 5:</span>
                  <strong className="text-white">06:00 - 22:00</strong>
                </div>
                <div className="d-flex justify-content-between mb-2 small text-light">
                  <span>Thứ 6:</span>
                  <strong className="text-white">06:00 - 23:00</strong>
                </div>
                <div className="d-flex justify-content-between small text-light">
                  <span>Thứ 7 & Chủ Nhật:</span>
                  <strong className="text-white">07:00 - 21:00</strong>
                </div>
              </div>
              <div className="mt-3 camera-text-info">
                <i className="bi bi-shield-check text-success fs-5"></i>
                <span>Giám sát Camera AI & Cổng an ninh 24/7</span>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom Bar */}
        <div className="footer-bottom-bar d-flex flex-wrap justify-content-between align-items-center gap-3">
          <div className="small" style={{ color: '#cbd5e1' }}>
            © {new Date().getFullYear()} Bãi Đỗ Xe Thông Minh IUH Parking - Trường Đại học Công nghiệp TP.HCM.
          </div>
          <div className="payment-badges">
            <span className="small me-2" style={{ color: '#cbd5e1' }}>Đối tác thanh toán:</span>
            <img src={logo1} alt="PayPal" />
            <img src={logo2} alt="Visa" />
            <img src={logo3} alt="Maestro" />
            <img src={logo4} alt="Discover" />
            <img src={logo5} alt="Mastercard" />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
